const serviceCategories = [
  {
    title: "시장 브리핑",
    subtitle: "Market Briefing",
    desc: "매일 아침, 국내 증시의 핵심 이슈와 투자 아이디어를 가장 빠르게 전달합니다.",
    items: [
      { icon: "ri-pulse-line", label: "국내 증시 이슈 분석" },
      { icon: "ri-lightbulb-flash-line", label: "테마 분석" },
      { icon: "ri-funds-line", label: "수급 분석" },
      { icon: "ri-radar-line", label: "실시간 시장 체크" },
    ],
    image: "https://readdy.ai/api/search-image?query=Korean%20stock%20market%20trading%20floor%20with%20multiple%20monitors%20displaying%20candlestick%20charts%20and%20real%20time%20market%20data%2C%20dark%20professional%20atmosphere%20with%20warm%20golden%20accent%20lighting%2C%20premium%20financial%20analysis%20environment%2C%20sophisticated%20investment%20advisory%20office%2C%20muted%20black%20and%20champagne%20gold%20color%20palette%2C%20cinematic%20editorial%20composition%2C%20blurred%20background%20with%20chart%20visualizations%2C%20luxury%20minimalist%20finance%20aesthetic%2C%20soft%20dramatic%20side%20lighting&width=1200&height=800&seq=prime-service-01&orientation=landscape",
  },
  {
    title: "종목 분석",
    subtitle: "Stock Analysis",
    desc: "멀티팩터 모델 기반의 심층 분석으로 개별 종목의 투자 판단을 명확히 제시합니다.",
    items: [
      { icon: "ri-search-eye-line", label: "보유 종목 진단" },
      { icon: "ri-swap-line", label: "매매 전략 제시" },
      { icon: "ri-arrow-up-down-line", label: "손절/목표가 안내" },
      { icon: "ri-shield-check-line", label: "리스크 관리" },
    ],
    image: "https://readdy.ai/api/search-image?query=Professional%20financial%20analyst%20examining%20detailed%20stock%20reports%20on%20a%20sleek%20black%20desk%20with%20minimal%20gold%20accents%2C%20multiple%20document%20stacks%20and%20a%20laptop%20showing%20valuation%20charts%2C%20dark%20modern%20office%20interior%2C%20soft%20warm%20lighting%20from%20above%2C%20premium%20investment%20research%20environment%2C%20muted%20black%20and%20champagne%20gold%20color%20palette%2C%20cinematic%20editorial%20composition%2C%20sophisticated%20minimalist%20finance%20aesthetic%2C%20sharp%20focus%20on%20documents&width=1200&height=800&seq=prime-service-02&orientation=landscape",
  },
];

export default function Services() {
  return (
    <section id="services" className="bg-background-100 py-20 md:py-32 border-y border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-3xl mb-16">
          <div className="text-xs md:text-sm tracking-widest text-primary-500 font-semibold mb-4">
            OUR SERVICES
          </div>
          <h2 className="font-heading font-black text-3xl md:text-5xl text-foreground-50 leading-tight tracking-tight">
            서비스
          </h2>
          <div className="gold-divider w-16 mt-8"></div>
        </div>

        <div className="space-y-16 md:space-y-24">
          {serviceCategories.map((cat, idx) => (
            <div
              key={cat.title}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center ${
                idx % 2 === 1 ? "lg:[direction:rtl]" : ""
              }`}
            >
              <div className={idx % 2 === 1 ? "lg:[direction:ltr]" : ""}>
                <div className="text-xs tracking-widest text-primary-500 mb-3">{cat.subtitle}</div>
                <h3 className="font-heading font-black text-2xl md:text-4xl text-foreground-50 leading-tight tracking-tight">
                  {cat.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-300 leading-relaxed mt-4">
                  {cat.desc}
                </p>

                <ul className="mt-8 space-y-4">
                  {cat.items.map((item) => (
                    <li
                      key={item.label}
                      className="flex items-center gap-4 group cursor-default"
                    >
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 border border-background-300/60 group-hover:border-primary-500/60 group-hover:bg-primary-500/10 transition-colors flex-shrink-0">
                        <i className={`${item.icon} text-primary-500 text-lg`}></i>
                      </div>
                      <span className="text-base md:text-lg text-foreground-100 font-medium">
                        {item.label}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className={idx % 2 === 1 ? "lg:[direction:ltr]" : ""}>
                <div className="relative overflow-hidden rounded-lg border border-background-300/50">
                  <img
                    src={cat.image}
                    alt={cat.title}
                    className="w-full aspect-[4/3] object-cover object-center"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 via-transparent to-transparent"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}